export var DEFAULT_INDICATOR_STYLE_PROPS = {
  backgroundFill: '#262626',
  backgroundLineCap: 'round',
  backgroundLineWidth: 1,
  backgroundStroke: '#333',
  backgroundZIndex: -1,
  formatter: function formatter(val) {
    return val.toString();
  },
  labelFill: '#fff',
  labelFontSize: 12,
  labelTextBaseline: 'middle',
  padding: [2, 4],
  position: 'right',
  zIndex: 999
};